import { LIST_BASED_FIELDS } from '../../constants/LIST_BASED_FIELDS'
import { createDebouncedAction } from '../utils'
import * as actionTypes from './actionTypes'
import { Map, fromJS } from 'immutable'

export const setElemValue = (uid, value, type, path, doNotProcessCondition, propName) => (dispatch) =>
  dispatch({ type: actionTypes.SET_ELEM_VALUE, payload: { uid, value, type, path, doNotProcessCondition, propName } })

export const setElementValueBatch = createDebouncedAction(actionTypes.SET_ELEM_VALUE_BATCH)

export const setElemValueById = (page, uid, value) => (dispatch, getState) => {
  const setElemValue = (uid, value, type, path, doNotProcessCondition, propName) => (dispatch) =>
    dispatch({
      type: actionTypes.SET_ELEM_VALUE,
      payload: { uid, value, type, path, doNotProcessCondition, propName, isIgnoreHidden: true },
    })
  try {
    let retState = getState()
    let pages = retState.getIn(['project', 'Pages'], Map())
    let targetPageID
    let elem
    if (retState.getIn(['project', 'Settings', 'elements', page])) {
      elem = retState.getIn(['project', 'Settings', 'elements', uid])
    } else {
      pages.map((row) => {
        if (row && row.get('uid') === page) {
          targetPageID = row.get('_id')
        }
      })
      if (!targetPageID) {
        return false
      }
      elem = retState.getIn(['pages', targetPageID, 'Props', 'elements', uid])
    }

    if (!elem) {
      return false
    }

    if (elem.get('type') === 'Typography') {
      dispatch(setElemValue([uid, 'TYPO_TEXT'], value, 'FormField', [page]))
    } else if (elem.get('type') === 'FormField') {
      const control = elem.getIn(['props', 'control'], 'text')
      let isListCheckbox = false
      if (control === 'checkbox') {
        isListCheckbox = elem.getIn(['props', 'source'], 'single') !== 'single'
      }
      if (control == 'multiSelect') {
        dispatch(setElemValue([uid], fromJS({ ftListValue: value }), 'FormField', [page]))
      } else if (LIST_BASED_FIELDS.includes(control) || isListCheckbox) {
        dispatch(setElemValue([uid], fromJS({ ftListValue: value }), 'FormField', [page]))
      } else if (control === 'currency') {
        dispatch(setElemValue([uid], fromJS({ value: value }), 'FormField', [page]))
      } else {
        dispatch(setElemValue([uid], value, 'FormField', [page]))
      }
      switch (control) {
        case 'datetime':
        case 'time':
        case 'date':
        case 'number':
          dispatch(setElemValue([`${uid}-formattedValue`], value, 'FormField', [page]))
          break
      }
    } else {
      dispatch(setElemValue([uid], value, 'FormField', [page]))
    }
  } catch (err) {
    console.error(err)
    dispatch(setElemValue([uid], value, 'FormField', [page]))
  }
}
